import React from "react";
import "./RingBindersCard.scss";
import CardPreview from "components/CardPreview/CardPreview";
const RingBindersCard = (props: any) => {
  const { title, data, config } = props;
  return (
    <div className="ring-binders-card-container">
      <h2 className="card-title">{title}</h2>
      <div>
        <CardPreview
          type={config?.previewType}
          icon={config?.previewIcon}
          valueDefinitions={config?.previewValueDefinitions}
          data={data}
        />
      </div>
    </div>
  );
};

export { RingBindersCard };
